import { render } from "./AddLocation.vue?vue&type=template&id=77e1bd4f&scoped=true"
import script from "./AddLocation.vue?vue&type=script&lang=js"
export * from "./AddLocation.vue?vue&type=script&lang=js"

import "./AddLocation.vue?vue&type=style&index=0&id=77e1bd4f&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77e1bd4f"]])

export default __exports__